var Actions;
(function (Actions) {
    Actions["GET_MAPPING_PROJECT_LIST"] = "getMappingProjectList";
    Actions["GET_MAPPING_PROJECT_LIST_CODE_DESC"] = "getMappingProjectListIdDesc";
    Actions["CREATE_MAPPING_PROJECT_LIST"] = "createMappingProjectList";
    Actions["UPDATE_MAPPING_PROJECT_LIST"] = "updateMappingProjectList";
    Actions["GET_MAPPING_PROJECT_LIST_FILTER"] = "getMappingProjectListFilter";
    Actions["UPDATE_MAPPING_PROJECT_SIZE"] = "updateMappingProjectSize";
    Actions["UPDATE_SELECTED_MAPPING_PROJECT_CODE"] = "updateSelectedMappingProjectID";
    Actions["UPDATE_SELECTED_MAPPING_PROJECT_DESC"] = "updateSelectedMappingProjectDesc";
    Actions["RESET_MAPPING_PROJECT_FILTER"] = "resetMappingProjectFilter";
    Actions["DOWNLOAD_MAPPING_PROJECT"] = "downloadMappingProject";
    Actions["GET_MAPPING_PROJECT_DATA"] = "getMappingProjectData";
    Actions["GET_MAPPING_PROJECT_DATA_UPDATE"] = "getMappingProjectDataUpdate";
    Actions["UPDATE_MAPPING_PROJECT_PAGE_FILTER"] = "updateMappingProjectPageFilter";
    Actions["UPDATE_MAPPING_PROJECT_CODE"] = "updateMappingProjectCode";
    Actions["UPDATE_MAPPING_PROJECT_DESC"] = "updateMappingProjectDesc";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_MAPPING_PROJECT_LOAD"] = "setMappingProjectWasFirstLoad";
    Mutations["SET_MAPPING_PROJECT_LOADING"] = "setMappingProjectLoading";
    Mutations["SET_MAPPING_PROJECT_HANDLE_PAGE"] = "setMappingProjectHandlePage";
    Mutations["SET_MAPPING_PROJECT_LIST"] = "setMappingProjectList";
    Mutations["SET_MAPPING_PROJECT_LIST_CODE"] = "setMappingProjectListBudgetItemID";
    Mutations["SET_MAPPING_PROJECT_LIST_DESC"] = "setMappingProjectListBudgetItemDesc";
    Mutations["SET_MAPPING_PROJECT_LIST_DIRECTORATE_CODE"] = "setMappingProjectListDirectorateCode";
    Mutations["SET_MAPPING_PROJECT_LIST_DIRECTORATE_NAME"] = "setMappingProjectListDirectorateName";
    Mutations["SET_MAPPING_PROJECT_LIST_FUNCTION_CODE"] = "setMappingProjectListFunctionCode";
    Mutations["SET_MAPPING_PROJECT_LIST_FUNCTION_NAME"] = "setMappingProjectListFunctionName";
    Mutations["SET_MAPPING_PROJECT_LIST_DIVISION_CODE"] = "setMappingProjectListDivisionCode";
    Mutations["SET_MAPPING_PROJECT_LIST_DIVISION_NAME"] = "setMappingProjectListDivisionName";
    Mutations["SET_MAPPING_PROJECT_LIST_DEPARTMENT_CODE"] = "setMappingProjectListDepartmentCode";
    Mutations["SET_MAPPING_PROJECT_LIST_DEPARTMENT_NAME"] = "setMappingProjectListDepartmentName";
    Mutations["SET_MAPPING_PROJECT_PAGE"] = "setMappingProjectPage";
    Mutations["SET_MAPPING_PROJECT_LOAD_PAGE"] = "setMappingProjectLoadPage";
    Mutations["SET_MAPPING_PROJECT_STATUS"] = "setMappingProjectStatus";
    Mutations["SET_MAPPING_PROJECT_SIZE"] = "setMappingProjectSize";
    Mutations["SET_SELECTED_MAPPING_PROJECT_CODE"] = "setSelectedMappingProjectCode";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DESC"] = "setSelectedMappingProjectDesc";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_CODE"] = "setSelectedMappingProjectDirectorateCode";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DIRECTORATE_NAME"] = "setSelectedMappingProjectDirectorateName";
    Mutations["SET_SELECTED_MAPPING_PROJECT_FUNCTION_CODE"] = "setSelectedMappingProjectFunctionCode";
    Mutations["SET_SELECTED_MAPPING_PROJECT_FUNCTION_NAME"] = "setSelectedMappingProjectFunctionName";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DIVISION_CODE"] = "setSelectedMappingProjectDivisionCode";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DIVISION_NAME"] = "setSelectedMappingProjectDivisionName";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_CODE"] = "setSelectedMappingProjectDepartmentCode";
    Mutations["SET_SELECTED_MAPPING_PROJECT_DEPARTMENT_NAME"] = "setSelectedMappingProjectDepartmentName";
    Mutations["SET_MAPPING_PROJECT_RESET"] = "setMappingProjectReset";
    Mutations["SET_MAPPING_PROJECT_USEFILTER"] = "setMappingProjectUseFilter";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE"] = "setMappingProjectListDataUpdate";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE_MAPPINGPROJECT"] = "setMappingProjectListDataUpdateMappingProject";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE_HIERARCHY"] = "setMappingProjectListDataUpdateHierarchy";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE_WBS"] = "setMappingProjectListDataUpdateWbs";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_HIERARCHY"] = "setMappingProjectListDataUpdateIndexHierarchy";
    Mutations["SET_MAPPING_PROJECT_LIST_DATAUPDATE_INDEX_WBS"] = "setMappingProjectListDataUpdateIndexWbs";
    Mutations["SET_MAPPING_PROJECT_PAGE_FILTER"] = "setMappingProjectPageFilter";
    Mutations["SET_MAPPING_PROJECT_WAS_LOAD_QUICK_FILTER"] = "setMappingProjectWasLoadQuickFilter";
    Mutations["SET_MAPPING_PROJECT_DESC"] = "setMappingProjectSelectedDesc";
    Mutations["SET_MAPPING_PROJECT_SEARCH_BY"] = "setMappingProjectSelectedSearchBy";
    Mutations["SET_MAPPING_PROJECT_FILTER_STATUS"] = "setMappingProjectSelecteFilterStatus";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
